// COMPONENTS
import { EventForm } from "../../../components/pages/EventForm";

export const CreateEvent = () => <EventForm />;
